import { Nullable } from '@internal-libraries/kheops-ui-lib'
import { User } from '../../../admin/vue/classes/User'
import { Patient } from '../../../dPpatients/vue/Classes/Patient'
import { OperationDto } from '../Type/OperationDto'
import { OperationType } from '../Type/OperationType'
import AnesthesiaType from './ClvrAnesthesiaType'
import ResourceType from '../../../dPbloc/vue/Classes/ClvrResourceType'
import { OperationTimeStatusEnum } from '../Enum'
import { format } from 'date-fns'
import Staff from '../../../dPpersonnel/vue/Classes/Staff'
import Stay from './Stay'
import Room from '../../../dPbloc/vue/Classes/ClvrRoom'
import {EnumStaffRole} from "../../../dPpersonnel/vue/Enum";

export default class ClvrOperation {
    public id: Nullable<number> = null
    public surgeonId: Nullable<number> = null
    public operatingRoomId: Nullable<number> = null
    public date: Nullable<string> = null
    public startOperation: Nullable<string> = null
    public timeOperation: Nullable<string> = null
    public label = ''
    public materials: Nullable<string> = null
    public remarks: Nullable<string> = null
    public stayId: Nullable<number> = null
    public roomId: Nullable<number> = null
    public emergency = false
    public cancelled = false

    public patient?: Patient
    public additionalMaterials: ResourceType[] = []
    public surgeon?: User
    public anesthetist?: User
    public anesthesiaType?: AnesthesiaType
    public operationTimeStatus: Nullable<OperationTimeStatusEnum> = null
    public staffs: Staff[] = []
    public stay?: Stay
    public room?: Room
    
    public anesthetistList: User[] = []
    
    public constructor(data?: OperationType) {
        Object.assign(this, data)
    }

    /**
     * Here we return a string which contains different data, we delete if necessary the comma at the end of the string
     * @return string
     */
    public get materialAndRemark(): string {
        const dataforOperation = [
            this.materials ?? '',
            this.remarks ?? '',
            this.additionalMaterials?.map(material => (material.label ? `${material.label}` : '')).join(' ,'),
        ]
        return dataforOperation.filter(Boolean).join(',')
    }

    public getTimeOperation(dateOp: Nullable<Date>): string {
        return dateOp ? format(dateOp, 'HH:mm') : ''
    }
    
    public setAnestesistListForScreenControl() {
        this.anesthetistList = Staff.getUserWithRoleFromStaff(this.staffs, EnumStaffRole.ANESTHETIST)
    }
    
    public getAnesthetistForScreenControlToString(): string {
        return this.anesthetistList.map(anesthetist => anesthetist.fullNameWithInitial).join(' ')
    }
    
    public toDto(): OperationDto {
        return {
            id: this.id,
            chir_id: this.surgeonId,
            sejour_id: this.stayId,
            salle_id: this.roomId,
            date: this.date,
            time_operation: this.startOperation,
            temp_operation: this.timeOperation,
            libelle: this.label,
            materiel: this.materials,
            rques: this.remarks,
            urgence: this.emergency,
            annulee: this.cancelled,
            _ref_patient: this.patient?.toDto(),
            _refs_materiels_operatoires: this.additionalMaterials,
            _ref_chir: this.surgeon?.toDto(),
            _ref_sejour: this.stay?.toDto(),
            _ref_salle: this.room?.toDto(),
            _ref_anesth: this.anesthetist?.toDto(),
            _ref_type_anesth: this.anesthesiaType?.toDto(),
            _operationTimeStatus: this.operationTimeStatus,
            _ref_personals: this.staffs.map(staff => staff.toDto()) || [],
        }
    }
}
